export enum MembershipType {
  Normal=0,
  Premium = 1
}
